import { useEffect, useState, useRef } from "react";
import Header from "../Header";
import Footer from "../Footer";
import axios from "axios";
import { API_URL } from "../constants";
import { es } from "date-fns/locale";

const Profile = () => {
  const [username, setUsername] = useState("");
  const [email, setEmail] = useState("");

  const [usernameInput, setUsernameInput] = useState("");
  const [emailInput, setEmailInput] = useState("");
  const [passwordInput, setPasswordInput] = useState("");
  const [firstNameInput, setFirstNameInput] = useState("");
  const [lastNameInput, setLastNameInput] = useState("");
  const [phoneInput, setPhoneInput] = useState("");

  const [isDisabled, setIsDisabled] = useState(true);
  const [message, setMessage] = useState("");
  const [emailMessage, setEmailMessage] = useState("");

  const [groupVisible, setGroupVisible] = useState(false);

  // VALIDATION FORM (EMAIL, PHONE, INPUT PASSWORD COMPARISON)

  // const [formIsValid, setFormIsValid] = useState(false);
  const passwordRef = useRef(null);
  const confirmpasswordRef = useRef(null);
  const emailRef = useRef(null);
  const telRef = useRef(null);

  // Email validation regex
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  // Phone validation regex
  const phoneRegex = /^\+\d[\d\s-]{8,}$/;

  const passwordValidation = (passwordRef, confirmpasswordRef) => {
    var isValid = passwordRef.value === confirmpasswordRef.value;
    if (!isValid) {
      confirmpasswordRef.classList.add("invalid");

      setMessage("Passwords did not match.");
      setIsDisabled(true);
    } else {
      confirmpasswordRef.classList.remove("invalid");

      setMessage("");
      setIsDisabled(false);
    }
    return isValid;
  };

  const formValidation = () => {
    const validate = passwordValidation(
      passwordRef.current,
      confirmpasswordRef.current
    );
    // setFormIsValid(validate);
  };

  const validateEmail = () => {
    const emailValue = emailRef.current.value;
    if (!emailRegex.test(emailValue)) {
      emailRef.current.classList.add("invalid");
      // setFormIsValid(false);

      setMessage("Invalid email.");
      setIsDisabled(true);
    } else {
      emailRef.current.classList.remove("invalid");
      // setFormIsValid(true);

      setMessage("");
      setIsDisabled(false);
    }
  };

  const validatePhone = () => {
    const telValue = telRef.current.value;
    if (!phoneRegex.test(telValue)) {
      telRef.current.classList.add("invalid");

      setMessage("Invalid phone number.");
      setIsDisabled(true);
    } else {
      telRef.current.classList.remove("invalid");
      // setFormIsValid(true);

      setMessage("");
      setIsDisabled(false);
    }
  };

  // VALIDATION FORM (EMAIL, PHONE, INPUT PASSWORD COMPARISON)

  const toggleGroup = () => {
    setGroupVisible(!groupVisible);
  };

  //INPUT-PASSWORD ==============================================

  const handleUsernameChange = (e) => {
    setUsernameInput(e.target.value);
  };

  const handleEmailChange = (e) => {
    setEmailInput(e.target.value);

    validateEmail();
  };

  const handleFirstNameChange = (e) => {
    setFirstNameInput(e.target.value);
  };

  const handleLastNameChange = (e) => {
    setLastNameInput(e.target.value);
  };

  const handlePhoneChange = (e) => {
    const input = e.target.value;

    const validData = input.replace(/[^\d\s+\-]/g, "");

    setPhoneInput(validData); // you can keep this for now

    validatePhone();
  };

  const handlePasswordChange = (e) => {
    setPasswordInput(e.target.value);
  };

  const getCurrentUser = () => {
    const token = localStorage.getItem("token");
    const userId = localStorage.getItem("userId");

    axios
      .get(API_URL + `auth/users/${userId}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((res) => {
        const data = res.data;
        setUsername(data.username);
        setEmail(data.email);

        setUsernameInput(data.username);
        setEmailInput(data.email);
        setFirstNameInput(data.first_name);
        setLastNameInput(data.last_name);
        setPhoneInput(data.phone_number);
      })
      .catch(() => {
        handleLogout();
      });
  };

  const handleSubmit = (e) => {
    // if (!formIsValid) {
    //   return;
    // }

    e.preventDefault();

    const token = localStorage.getItem("token");
    const userId = localStorage.getItem("userId");

    axios
      .put(
        API_URL + `auth/users/${userId}`,
        {
          username: usernameInput,
          first_name: firstNameInput,
          last_name: lastNameInput,
          phone_number: phoneInput,
          password: passwordInput,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
      .then((res) => {
        if (res.status === 200) {
          setMessage("User was successfully updated!");
          setTimeout(() => {
            getCurrentUser();
            setMessage("");
            setIsDisabled(true)
          }, 5000);
        }
      })
      .catch((err) => {
        if (err.response.data.username) {
          setMessage(err.response.data.username[0]);
        }
      });

    if (emailInput !== email) {
      axios
        .post(
          API_URL + "auth/change-email/",
          {
            new_email: emailInput,
            user_id: userId,
          },
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        )
        .then((res) => {
          setEmailMessage(res.data.detail);
        });
    }
  };

  const handleLogout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("userId");
    localStorage.removeItem("username");

    window.location.href = "/";
  };

  useEffect(() => {
    getCurrentUser();
  }, []);

  return (
    <>
      <Header />

      <div className="wrapper">
        <main className="page">
          <div className="main-section">
            <div className="container-fix-width">
              <div className="user-profile container-styles">
                <div className="user-profile__info">
                  <div className="user-profile__data">
                    <svg
                      width="30"
                      height="30"
                      viewBox="0 0 30 30"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        className="vector-white-to-black"
                        d="M15 15C18.1993 15 21.4286 12.6804 21.4286 7.5C21.4286 5.79503 20.7513 4.1599 19.5457 2.95431C18.3401 1.74872 16.7049 1.07143 15 1.07143C13.295 1.07143 11.6599 1.74872 10.4543 2.95431C9.24871 4.1599 8.57141 5.79503 8.57141 7.5C8.57141 12.6804 11.8007 15 15 15ZM15 3.21428C16.1366 3.21428 17.2267 3.66581 18.0304 4.46954C18.8342 5.27327 19.2857 6.36336 19.2857 7.5C19.2857 10.8546 17.6786 12.8571 15 12.8571C12.3214 12.8571 10.7143 10.8546 10.7143 7.5C10.7143 6.36336 11.1658 5.27327 11.9695 4.46954C12.7733 3.66581 13.8633 3.21428 15 3.21428Z"
                        fill="white"
                      />
                      <path
                        d="M14.9999 17.1429C8.39138 17.1429 3.21423 19.9961 3.21423 23.6389C3.21423 27.0493 7.39923 28.9286 14.9999 28.9286C22.6007 28.9286 26.7857 27.0493 26.7857 23.6389C26.7857 19.9961 21.6085 17.1429 14.9999 17.1429ZM14.9999 26.7857C9.14138 26.7857 5.35709 25.5504 5.35709 23.6389C5.35709 21.5796 9.32138 19.2857 14.9999 19.2857C20.6785 19.2857 24.6428 21.5796 24.6428 23.6389C24.6428 25.5504 20.8585 26.7857 14.9999 26.7857Z"
                        fill="#FF8000"
                      />
                    </svg>
                    <div className="user-contacts">
                      <div className="user-name">{username}</div>
                      <div className="user-email">{email}</div>
                    </div>
                  </div>
                  <span onClick={handleLogout} className="user-profile__logout-btn">
                    <svg
                      width="30"
                      height="30"
                      viewBox="0 0 30 30"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        className="vector-white-to-black"
                        d="M18.2143 19.2857C17.9301 19.2857 17.6576 19.3986 17.4567 19.5995C17.2557 19.8004 17.1428 20.0729 17.1428 20.3571V23.7653L3.21427 26.55V3.44996L17.1428 6.23567V9.64281C17.1428 9.92698 17.2557 10.1995 17.4567 10.4004C17.6576 10.6014 17.9301 10.7142 18.2143 10.7142C18.4984 10.7142 18.771 10.6014 18.9719 10.4004C19.1728 10.1995 19.2857 9.92698 19.2857 9.64281V5.3571C19.2857 5.1101 19.2005 4.87067 19.0443 4.67934C18.8881 4.488 18.6706 4.3565 18.4286 4.3071L2.35713 1.09281C2.20144 1.06103 2.04063 1.06428 1.88636 1.10232C1.73208 1.14036 1.58819 1.21223 1.46512 1.31274C1.34205 1.41325 1.24288 1.53987 1.17478 1.68344C1.10669 1.827 1.07138 1.98392 1.07141 2.14281V27.8571C1.07138 28.016 1.10669 28.1729 1.17478 28.3165C1.24288 28.46 1.34205 28.5867 1.46512 28.6872C1.58819 28.7877 1.73208 28.8596 1.88636 28.8976C2.04063 28.9356 2.20144 28.9389 2.35713 28.9071L18.4286 25.6928C18.6706 25.6434 18.8881 25.5119 19.0443 25.3206C19.2005 25.1292 19.2857 24.8898 19.2857 24.6428V20.3571C19.2857 20.0729 19.1728 19.8004 18.9719 19.5995C18.771 19.3986 18.4984 19.2857 18.2143 19.2857Z"
                        fill="white"
                      />
                      <path
                        d="M28.6146 14.2425L23.2574 8.88536C23.0554 8.69019 22.7847 8.58219 22.5038 8.58464C22.2229 8.58708 21.9542 8.69976 21.7555 8.89841C21.5568 9.09706 21.4442 9.36579 21.4417 9.64671C21.4393 9.92764 21.5473 10.1983 21.7424 10.4004L25.2707 13.9286H11.7857C11.5015 13.9286 11.229 14.0415 11.028 14.2424C10.8271 14.4433 10.7142 14.7158 10.7142 15C10.7142 15.2842 10.8271 15.5567 11.028 15.7576C11.229 15.9585 11.5015 16.0714 11.7857 16.0714H25.2707L21.7424 19.5996C21.6401 19.6985 21.5585 19.8167 21.5023 19.9474C21.4462 20.0781 21.4166 20.2187 21.4154 20.361C21.4142 20.5033 21.4413 20.6443 21.4951 20.776C21.549 20.9077 21.6286 21.0273 21.7292 21.1279C21.8298 21.2285 21.9494 21.3081 22.0811 21.362C22.2127 21.4158 22.3538 21.4429 22.4961 21.4417C22.6384 21.4405 22.7789 21.4109 22.9097 21.3548C23.0404 21.2986 23.1586 21.217 23.2574 21.1146L28.6146 15.7575C28.8155 15.5566 28.9283 15.2841 28.9283 15C28.9283 14.7159 28.8155 14.4434 28.6146 14.2425Z"
                        fill="#FF8000"
                      />
                    </svg>
                  </span>
                </div>
                <form
                  className="user-profile-form form-styles"
                  onSubmit={handleSubmit}
                >
                  <div className="form__inputs-container">
                    <div className="form-input__wrap">
                      <label for="userName">Username</label>
                      <input
                        type="text"
                        name="userName"
                        id="userName"
                        value={usernameInput}
                        onChange={handleUsernameChange}
                        required
                      />
                    </div>
                    <div className="form-input__wrap half-width">
                      <label for="firstName">First Name</label>
                      <input
                        type="text"
                        name="firstName"
                        id="firstName"
                        value={firstNameInput}
                        onChange={handleFirstNameChange}
                      />
                    </div>
                    <div className="form-input__wrap half-width">
                      <label for="lastName">Last Name</label>
                      <input
                        type="text"
                        name="lastName"
                        id="lastName"
                        value={lastNameInput}
                        onChange={handleLastNameChange}
                      />
                    </div>
                    <div className="form-input__wrap half-width">
                      <label for="userEmail">Email</label>
                      <input
                        ref={emailRef}
                        type="email"
                        name="userEmail"
                        id="userEmail"
                        value={emailInput}
                        onChange={handleEmailChange}
                        required
                      // onBlur={validateEmail}
                      />
                    </div>
                    <div className="form-input__wrap half-width">
                      <label for="userTel">Phone</label>
                      <input
                        ref={telRef}
                        type="text"
                        name="userTel"
                        placeholder="e.g. +123456789"
                        id="userTel"
                        value={phoneInput}
                        onChange={handlePhoneChange}
                      // onBlur={validatePhone}
                      />
                    </div>

                    <div className="form-input__wrap half-width">
                      <label for="newPassw">New Password</label>
                      <div className="password-input">
                        <input
                          type={groupVisible ? "text" : "password"}
                          ref={passwordRef}
                          className="input__password password-group password-main"
                          name="newPassw"
                          id="newPassw"
                          autocomplete="new-password"
                          onChange={handlePasswordChange}
                          onBlur={formValidation}
                        />
                        <span
                          className={`show-password-input ${groupVisible ? "display-password" : ""
                            }`}
                          onClick={toggleGroup}
                        ></span>
                      </div>
                    </div>
                    <div className="form-input__wrap half-width">
                      <label for="confNewPassw">Confirm New Password</label>
                      <div className="password-input">
                        <input
                          type={groupVisible ? "text" : "password"}
                          ref={confirmpasswordRef}
                          className="input__password password-group password-confirm"
                          name="confNewPassw"
                          id="confNewPassw"
                          autocomplete="new-password"
                          onBlur={formValidation}
                        />
                        <span
                          className={`show-password-input ${groupVisible ? "display-password" : ""
                            }`}
                          onClick={toggleGroup}
                        ></span>
                      </div>
                    </div>
                  </div>

                  {message ? (
                    <p className="profile-message">{message}</p>
                  ) : (
                    <></>
                  )}

                  {emailMessage ? (
                    <p className="profile-message">{emailMessage}</p>
                  ) : (
                    <></>
                  )}
                  <button
                    type="submit"
                    className="main-btn"
                    disabled={isDisabled}
                    name="userProfBtn"
                  >
                    Save Changes
                  </button>
                </form>
              </div>
            </div>
          </div>
        </main>
      </div>

      <Footer />
    </>
  );
};

export default Profile;
